import { FC, useEffect, useState } from 'react';
import { TableListQueryResponse } from '../../../_core/interfaces/table-list-query.interface';
import { FamilyWithSurveyDto } from '@families-link/shared';
import { useTranslation } from 'react-i18next';
import { useReactTable, getCoreRowModel, getSortedRowModel, SortingState } from '@tanstack/react-table';
import { CoreTable, CoreTableEmptyBody } from '../../../_core/components/_ui/core-table';
import { useFamilyAttachTableColumns } from '../../hooks/table-columns/family-attach-table-colums.hook copy';
import { RadioGroup } from '@mui/material';

export interface FamilyAttachTableHandlers {
	onRowSelect(familyId: string): void;
}

type FamilyAttachTableProps = TableListQueryResponse<FamilyWithSurveyDto> &
	FamilyAttachTableHandlers & { selectedRowId: string | null };

export const FamilyAttachTable: FC<FamilyAttachTableProps> = (props) => {
	const { data, loading, fetchMore, scrollRef, onRowSelect, selectedRowId } = props;
	const [isFirstrender, setIsFirstRender] = useState(false);
	const [sorting, setSorting] = useState<SortingState>([]);
	const [t] = useTranslation();

	useEffect(() => {
		if (!isFirstrender) {
			setIsFirstRender(true);
		}
	}, []);

	const columns = useFamilyAttachTableColumns({ onRowSelect }, selectedRowId);

	const table = useReactTable<FamilyWithSurveyDto>({
		data,
		columns,
		state: {
			sorting,
		},
		onSortingChange: setSorting,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
	});

	return (
		<CoreTable
			px={0}
			ref={scrollRef}
			loading={loading}
			threshold={200}
			emptyListComponent={
				<CoreTableEmptyBody label={t('profile.sessions.table.empty-title')} description={'No options'} />
			}
			fetchMore={fetchMore}
			rowModel={table.getRowModel()}
			headerGroups={table.getHeaderGroups()}
		/>
	);
};
